export const REGISTER_PAGE = 'register_page';
export const CONFIRMATION_PAGE = 'confirmation_page';
export const WORKSPACE_PAGE = 'workspace_page';
